@if (href()) {
    <a
        part="link"
        [attr.href]="href()"
        [attr.target]="target()"
        [attr.download]="download()"
        [class.bh-events-none]="disabled()"
    >
        <ng-container [ngTemplateOutlet]="innerTpl"></ng-container>
    </a>
} @else {
    <span [class.bh-events-none]="disabled()">
        <ng-container [ngTemplateOutlet]="innerTpl"></ng-container>
    </span>
}

<ng-template #innerTpl>
    <slot name="start"></slot>
    <span class="bazis-link__text">
        <slot></slot>
    </span>
    <slot name="end"></slot>
</ng-template>
